import getStroke from 'perfect-freehand';

// Tool presets for perfect-freehand
export const TOOL_OPTIONS = {
  pencil: {
    size: 3,
    thinning: 0.5,
    smoothing: 0.5,
    streamline: 0.5,
    simulatePressure: true,
    start: { taper: 0 },
    end: { taper: 0 },
  },
  brush: {
    size: 12,
    thinning: 0.6,
    smoothing: 0.8,
    streamline: 0.6,
    simulatePressure: true,
    start: { taper: 40 },
    end: { taper: 40 },
  },
  marker: {
    size: 20,
    thinning: 0,
    smoothing: 0.5,
    streamline: 0.3,
    simulatePressure: false,
    start: { taper: 0 },
    end: { taper: 0 },
  },
  pen: {
    size: 2,
    thinning: 0.7,
    smoothing: 0.9,
    streamline: 0.8,
    simulatePressure: true,
    start: { taper: 20 },
    end: { taper: 20 },
  },
  eraser: {
    size: 20,
    thinning: 0,
    smoothing: 0.5,
    streamline: 0.3,
    simulatePressure: false,
    start: { taper: 0 },
    end: { taper: 0 },
  },
};

/**
 * Convert perfect-freehand outline points to an SVG path d attribute.
 * Standard approach from the perfect-freehand docs.
 */
export function getSvgPathFromStroke(points) {
  if (!points.length) return '';

  const d = points.reduce(
    (acc, [x0, y0], i, arr) => {
      const [x1, y1] = arr[(i + 1) % arr.length];
      acc.push(x0, y0, (x0 + x1) / 2, (y0 + y1) / 2);
      return acc;
    },
    ['M', ...points[0], 'Q']
  );

  d.push('Z');
  return d.join(' ');
}

/**
 * Get the SVG path data for a stroke, given raw input points and tool settings.
 */
export function getStrokePath(inputPoints, tool, userSize, userOpacity) {
  const options = {
    ...TOOL_OPTIONS[tool] || TOOL_OPTIONS.pencil,
    size: userSize,
  };
  const outlinePoints = getStroke(inputPoints, options);
  return getSvgPathFromStroke(outlinePoints);
}

/**
 * Flatten [[x,y], [x,y], ...] to [x,y,x,y,...] for compact RTDB storage.
 */
export function flattenPoints(points) {
  const flat = new Array(points.length * 2);
  for (let i = 0; i < points.length; i++) {
    flat[i * 2] = Math.round(points[i][0] * 10) / 10;
    flat[i * 2 + 1] = Math.round(points[i][1] * 10) / 10;
  }
  return flat;
}

/**
 * Unflatten [x,y,x,y,...] back to [[x,y], [x,y], ...] for rendering.
 */
export function unflattenPoints(flat) {
  const points = [];
  for (let i = 0; i < flat.length; i += 2) {
    points.push([flat[i], flat[i + 1]]);
  }
  return points;
}
